module.exports = __webpack_public_path__ + "static/media/planeta1.4d40288e.png";